<template>
	<div class="">
		<!-- begin progress bar  -->
		<vue-progress-bar></vue-progress-bar>
		<router-view></router-view>
		<!-- Idle warning modal -->
		<IdleWarningModal 
			:is-idle="isIdle" 
			:time-left="timeLeft" 
			:stay-logged-in="stayLoggedIn" 
		/>
	</div>
</template>

<script>
import { useIdleDetection } from '../composables/useIdleDetection'
import IdleWarningModal from '../src/views/components/IdleWarningModal.vue' // Complete the import path

export default {
	components: {
		IdleWarningModal
	},
	data() {
		return {
			idleDetection: null
		}
	},
	created() {
		this.idleDetection = useIdleDetection(this.$router)
		this.idleDetection.initializeIdleDetection()
	},
	beforeDestroy() {
		if (this.idleDetection) {
			this.idleDetection.stopIdleDetection()
		}
	},
	computed: {
		isIdle() { 
			return this.idleDetection ? this.idleDetection.state.isIdle : false 
		},
		timeLeft() { 
			return this.idleDetection ? this.idleDetection.state.timeLeft : 0 
		}
	},
	methods: {
		stayLoggedIn() { 
			if (this.idleDetection) {
				this.idleDetection.stayLoggedIn() 
			}
		}
	}
}
</script>